import React, { useState, useEffect, useContext } from "react"
import { useHistory } from "react-router-dom"

import RegistradorContext from "../../../../contexts/registradorContext"
import ServicosContext from "../../../../contexts/servicosContext"
import { useSnackbar } from "notistack"

import Package from "../../../../../package.json"

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import CheckIcon from "@material-ui/icons/Check"
import Backdrop from "@material-ui/core/Backdrop"
import Radio from "@material-ui/core/Radio"
import AlertFixo from "@material-ui/lab/Alert"
import PhoneIcon from "@material-ui/icons/Phone"
import EditIcon from "@material-ui/icons/Edit"
import RadioGroup from "@material-ui/core/RadioGroup"
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import NativeSelect from "@material-ui/core/NativeSelect"
import PrintIcon from "@material-ui/icons/Print"
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation"
import PaymentIcon from "@material-ui/icons/Payment"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import CardActions from "@material-ui/core/CardActions"
import SwapHorizIcon from "@material-ui/icons/SwapHoriz"
import InputAdornment from "@material-ui/core/InputAdornment"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import InputBase from "@material-ui/core/InputBase"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import FormLabel from "@material-ui/core/FormLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Skeleton from "@material-ui/lab/Skeleton"
import FormControl from "@material-ui/core/FormControl"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import ArrowRightIcon from "@material-ui/icons/ArrowRight"
import CircularProgress from "@material-ui/core/CircularProgress"
import Button from "@material-ui/core/Button"
import ListSubheader from "@material-ui/core/ListSubheader"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import PersonPinIcon from "@material-ui/icons/PersonPin"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import { Card, Row, Col } from "react-bootstrap"
import Avatar from "@material-ui/core/Avatar"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Divider from "@material-ui/core/Divider"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Fab from "@material-ui/core/Fab"
import Slide from "@material-ui/core/Slide"
import InputLabel from "@material-ui/core/InputLabel"
import clsx from "clsx"
import Drawer from "@material-ui/core/Drawer"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import * as Sentry from "@sentry/react"

import TelefoneMask from "../../../../masks/telefone"

import Megafone from "../../../../assets/megafone.svg"
import Comida from "../../../../assets/comida.svg"

import { listarClientes, RegistrarLogErro } from "../../../../services/clientefiel"

import { BuscarMesas } from "../../../../services/integracao"

import {
    calcularValorAPartirDe,
    enderecoRetiradaNoLocal,
    carrinhoNovo,
    enderecoClienteNaLoja,
    procurarCategoria,
    procurarProduto,
    quantidadeButton,
    checkButton,
    radioButton,
    calcularValorTotal,
    produtoProntoParaCarrinho,
    calcularValorProduto,
    procurarProdutoPromocional,
} from "../../../../pages/RegistradorDePedidos/functions"

const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

function TabPanel(props) {
    const { children, ...other } = props

    return (
        <div role="tabpanel" {...other}>
            <Box p={3}>
                <div>{children}</div>
            </Box>
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
}

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

export default function Index() {
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const {
        listaRepeticao,
        setProdutoSelecionado,
        loadingCardapio,
        setLoadingCardapio,
        setOpenFinalizacaoPedido,
        isRetiradaNoLocal,
        isDelivery,
        setCarrinho,
        cardapio,
        openCardapio,
        produtoSelecionado,
        carrinho,
        setCardapio,
        valorDescontoManual,
        setOpenFormasDePagamento,
        ativarDesativarDesconto,
        ativoMinimoEntregaGratis,
        descontoAtivo,
        setOpenCardapio,
        isFreteGratisDesconto,
        isFreteGratisMinimoEntrega,
        descontoAtivoPagamento,
    } = useContext(RegistradorContext)

    const classes = useStyles()
    const [activeStep, setActiveStep] = React.useState(0)
    const grupoDeOpcoesSelecionado = produtoSelecionado?.opcoes?.length
        ? produtoSelecionado?.opcoes[activeStep]
        : {}
    const sortByOrdemExibicao = (a, b) => {
        if (a.ordemExib > b.ordemExib) {
            return 1
        } else if (a.ordemExib < b.ordemExib) {
            return -1
        }
        return 0
    }
    const listaTeste = ["produto2", "produto1", "produto9", "produto7"]
    const [skipped, setSkipped] = React.useState(new Set())
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    })

    const { enqueueSnackbar } = useSnackbar()

    const { configuracoes } = useContext(ServicosContext)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleCloseCardapio = () => {
        try {
            document.getElementById("procurar-cliente").value = ""
            setOpenCardapio(false)
            setCardapio({})
        } catch (error) {
            RegistrarLogErro(error, "handleCloseCardapio")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return
        }
        setState({ ...state, [anchor]: open })
    }

    const toggleDrawerProduto = (anchor, open, produto) => event => {
        try {
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return
            }
            setState({ ...state, [anchor]: open })
            setActiveStep(0)
            produto.quantidade = 1
            produto.opcoes.forEach(grupo => {
                grupo.quantidade = 0
            })
            setProdutoSelecionado(produto)
        } catch (error) {}
    }

    const removerProdutoCarrinho = produto => {
        try {
            console.log("||> removerProdutoCarrinho")
            //funcao para remover quantidade ou produto na tela de cardapio
            var temNoCarrinho = false
            var novoCardapio = cardapio
            //verificar se exite o produto no carrinho
            //altera a quantidade ou remove do carrinho
            let cart = Object.assign({}, carrinho)

            cart.itens.forEach((item, index) => {
                if (temNoCarrinho == false && item.produto.id == produto.id) {
                    const valorProduto = item.valorProdutoHistorico / item.quantidade

                    const qtdRemover = item.produto.qntMultiplicativaProdutos
                        ? item.produto.qntMultiplicativaProdutos
                        : 1
                    item.quantidade -= qtdRemover
                    if (item.quantidade == 0 || item.quantidade < item.produto.qntMinimaProdutos) {
                        item.quantidade = 0 // para item.quantidade < item.qntMinimaProdutos
                        const removido = cart.itens.splice(index, 1) //remvoer do carrinho
                        console.log("removido", removido)
                    } else {
                        item.valorProdutoHistorico -= valorProduto * qtdRemover
                        temNoCarrinho = true
                    }
                }
            })

            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
            })
            setCarrinho(cart)
        } catch (error) {
            RegistrarLogErro(error, "removerProdutoCarrinho", { produto, carrinho })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function selecionarCheckButton(opcaoAdd, grupoDeOpcoesSelecionado) {
        try {
            console.log("||> selecionarCheckButton", opcaoAdd, grupoDeOpcoesSelecionado)
            setProdutoSelecionado(
                checkButton(opcaoAdd, grupoDeOpcoesSelecionado, produtoSelecionado)
            )
        } catch (error) {
            RegistrarLogErro(error, "selecionarCheckButton", { opcaoAdd, grupoDeOpcoesSelecionado })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function selecionarQuantidadeButton(add, index, acao) {
        try {
            setProdutoSelecionado(quantidadeButton(add, index, acao, produtoSelecionado))
        } catch (error) {
            RegistrarLogErro(error, "selecionarQuantidadeButton", { add, index, acao })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function selecionarRadioButton(add, index) {
        try {
            console.log("||> selecionarRadioButton")
            setProdutoSelecionado(radioButton(add, index, produtoSelecionado))
        } catch (error) {
            RegistrarLogErro(error, "selecionarRadioButton", { add, index })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const list = anchor => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === "top" || anchor === "bottom",
            })}
            style={{ width: "100%" }}
            role="presentation"
        >
            {
                <List
                    component="div"
                    aria-labelledby="nested-list-subheader"
                    className={classes.rootCarrinho}
                >
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        className="mt-2"
                        style={{ backgroundColor: "#fff" }}
                    >
                        <Row
                            style={{
                                width: "100%",
                                top: "auto",
                                padding: "0",
                                margin: "0",
                            }}
                        >
                            <Col xs={12} md={12} lg={12}>
                                <Button onClick={toggleDrawer("right", false)} fullWidth>
                                    Adicionar Mais Produtos
                                </Button>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    variant="contained"
                                    onClick={e => {
                                        toggleDrawer("right", false)(e)

                                        if (carrinho.tipoPedido === 2) {
                                            const formaPagamento = cardapio.formasPagamento.filter(
                                                pg => pg.id === 41
                                            ) // forma pagamento pedido mesa
                                            if (formaPagamento.length) {
                                                carrinho.formaPagamento = formaPagamento[0]
                                            }
                                        }

                                        setOpenFinalizacaoPedido(true)
                                    }}
                                    fullWidth
                                    style={{ background: "#28a745", color: "white" }}
                                >
                                    {`Finalizar ${Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(carrinho.valorTotal)}`}
                                </Button>
                            </Col>
                        </Row>
                        <b> ({carrinho.itens.length}) Produtos adicionados:</b>
                    </ListSubheader>

                    <ListItem button>
                        <ListItemAvatar>
                            <Avatar>
                                {isDelivery ? (
                                    <MotorcycleIcon />
                                ) : isRetiradaNoLocal ? (
                                    <TransferWithinAStationIcon />
                                ) : (
                                    <AirlineSeatReclineNormalIcon />
                                )}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                isDelivery
                                    ? "Pedido Para Delivery"
                                    : isRetiradaNoLocal
                                    ? "Pedido Para Retirada"
                                    : "Pedido Para Mesa"
                            }
                        />
                        <ListItemText
                            style={{ textAlign: "right" }}
                            primary={Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                            }).format(
                                isFreteGratisDesconto || isFreteGratisMinimoEntrega || !isDelivery
                                    ? 0.0
                                    : carrinho.end.taxaEntrega
                            )}
                        />
                    </ListItem>

                    {isDelivery ? (
                        <List component="div" disablePadding>
                            <ListItem className={classes.nested} style={{ paddingTop: "0" }}>
                                {carrinho.end.logradouro + " - n°: " + carrinho.end.numero}
                            </ListItem>
                            <ListItem className={classes.nested} style={{ paddingTop: "0" }}>
                                {carrinho.end.cidade + " - " + carrinho.end.uf}
                            </ListItem>
                            {carrinho.end.complemento && (
                                <ListItem className={classes.nested} style={{ paddingTop: "0" }}>
                                    {carrinho.end.complemento}
                                </ListItem>
                            )}
                            {carrinho.end.referencia && (
                                <ListItem className={classes.nested} style={{ paddingTop: "0" }}>
                                    {carrinho.end.referencia}
                                </ListItem>
                            )}
                        </List>
                    ) : null}
                    <Divider />

                    {carrinho.valorDesconto || carrinho.backUpValorDesconto ? (
                        <>
                            <ListItem button>
                                <ListItemAvatar>
                                    <Avatar>
                                        <ConfirmationNumberIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={"Desconto"} />
                                <ListItemText
                                    style={{ textAlign: "right" }}
                                    primary={Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(
                                        carrinho.valorDesconto
                                            ? carrinho.valorDesconto
                                            : carrinho.backUpValorDesconto
                                    )}
                                    secondary={
                                        <Button
                                            onClick={ativarDesativarDesconto}
                                            style={{
                                                padding: "0px",
                                                float: "right",
                                                fontSize: "80%",
                                            }}
                                            className={
                                                descontoAtivo
                                                    ? "desconto-ativado"
                                                    : "desconto-desativado"
                                            }
                                        >
                                            {descontoAtivo ? "Ativado" : "Desativado"}
                                        </Button>
                                    }
                                    className={
                                        descontoAtivo ? "desconto-ativado" : "desconto-desativado"
                                    }
                                />
                            </ListItem>
                            <List component="div" disablePadding>
                                <ListItem className={classes.nested} style={{ paddingTop: "0" }}>
                                    {cardapio?.cupomDesconto?.codigoCupom ? (
                                        <ListItemText
                                            secondary={
                                                cardapio.cupomDesconto.mensagem
                                                    ? cardapio.cupomDesconto.mensagem
                                                    : `Cupom de desconto ${
                                                          cardapio.cupomDesconto.codigoCupom
                                                      } ${
                                                          cardapio.cupomDesconto.freteGratis
                                                              ? "com frete grátis"
                                                              : ""
                                                      }`
                                            }
                                        />
                                    ) : null}
                                    {cardapio?.informacao ? (
                                        <ListItemText
                                            secondary={
                                                cardapio?.informacao
                                                    ? cardapio?.informacao
                                                    : `Desconto`
                                            }
                                        />
                                    ) : null}
                                </ListItem>
                            </List>
                            <Divider />
                        </>
                    ) : null}

                    {carrinho.itens.map((item, index) => (
                        <div key={index} style={{ position: "relative" }}>
                            <ListItem button>
                                <ListItemAvatar>
                                    {item.produto.urlImagem ? (
                                        <Avatar
                                            style={{
                                                backgroundImage: `url(${item.produto.urlImagem})`,
                                                backgroundSize: "cover",
                                            }}
                                        >
                                            <> </>
                                        </Avatar>
                                    ) : (
                                        <Avatar
                                            className={"opacity05"}
                                            style={{
                                                backgroundImage: `url(${
                                                    item.produto.produtoExibicao
                                                        ? Megafone
                                                        : /**Prato */ Comida
                                                })`,
                                                backgroundSize: "cover",
                                                backgroundColor: "white",
                                            }}
                                        >
                                            <> </>
                                        </Avatar>
                                    )}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={item.quantidade + "x " + item.produto.nome}
                                />
                                <ListItemText
                                    style={{ textAlign: "right" }}
                                    primary={Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(item.valorProdutoHistorico)}
                                    secondary={
                                        <Button
                                            onClick={() => {
                                                removerProdutoCarrinho(item.produto)
                                            }}
                                            style={{
                                                padding: "0px",
                                                float: "right",
                                                fontSize: "80%",
                                                color: `#dc3545`,
                                            }}
                                        >
                                            Remover
                                        </Button>
                                    }
                                    className="carrinho-produto-valor"
                                />
                            </ListItem>

                            {item.produto.promocional &&
                            (cardapio?.valorDesconto || cardapio?.percentualDesconto) ? (
                                <List key={index} component="div" disablePadding>
                                    <ListItem
                                        className={classes.nested}
                                        style={{ paddingTop: "0" }}
                                    >
                                        <ListItemText
                                            secondary={"É promocional, então não recebe desconto."}
                                        />
                                    </ListItem>
                                </List>
                            ) : null}
                            {!!item.itensOpcaoProduto.length &&
                                item.itensOpcaoProduto.map((adicional, index) => (
                                    <List key={index} component="div" disablePadding>
                                        <ListItem
                                            className={classes.nested}
                                            style={{ paddingTop: "0" }}
                                        >
                                            <ListItemText
                                                secondary={
                                                    adicional.quantidade +
                                                    "x " +
                                                    adicional.opcaoProduto.nome
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                ))}

                            <Divider />
                        </div>
                    ))}
                </List>
            }
        </div>
    )

    const product = (anchor, produtoSelecionado) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === "top" || anchor === "bottom",
            })}
            role="presentation"
            style={{ padding: "2em" }}
        >
            <Stepper activeStep={activeStep} style={{ padding: 0, marginBottom: "2em" }}>
                {produtoSelecionado?.opcoes?.map((label, index) => {
                    const stepProps = {}
                    const labelProps = {}
                    if (isStepOptional(index)) {
                        labelProps.optional = <Typography variant="caption">Optional</Typography>
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false
                    }
                    return (
                        <Step key={label.nome} {...stepProps}>
                            <StepLabel {...labelProps}>{label.nome}</StepLabel>
                        </Step>
                    )
                })}
            </Stepper>
            <div>
                {activeStep === produtoSelecionado?.opcoes?.length ? (
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Typography style={{ textAlign: "center" }}>
                                Quantos desse produto?
                            </Typography>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="colOpcaoAdicionalProduto">
                            <ButtonGroup>
                                <Button
                                    aria-label="reduce"
                                    onClick={() => {
                                        if (produtoSelecionado.quantidade > 1) {
                                            setProdutoSelecionado({
                                                ...produtoSelecionado,
                                                quantidade: produtoSelecionado.quantidade - 1,
                                            })
                                        }
                                    }}
                                    style={{ background: "#dc3545", color: "white" }}
                                >
                                    <RemoveIcon fontSize="small" />
                                </Button>

                                <Button aria-label="increase">
                                    <span>{produtoSelecionado.quantidade}</span>
                                </Button>

                                <Button
                                    aria-label="increase"
                                    style={{ background: "#28a745", color: "white" }}
                                    onClick={() => {
                                        setProdutoSelecionado({
                                            ...produtoSelecionado,
                                            quantidade: produtoSelecionado.quantidade + 1,
                                        })
                                    }}
                                >
                                    <AddIcon fontSize="small" />
                                </Button>
                            </ButtonGroup>
                        </Col>

                        {produtoSelecionado.permiteObservacao ? (
                            <>
                                <Col xs={12} md={12} lg={12} style={{ marginTop: "1em" }}>
                                    <Typography style={{ textAlign: "center" }}>
                                        Alguma observação?
                                    </Typography>
                                </Col>
                                <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                                    <TextField
                                        style={{ margin: "0" }}
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        id={`observacaoPedido_${produtoSelecionado.id}`}
                                        label="Observação"
                                        name="observacaoPedido"
                                        type="text"
                                    ></TextField>
                                </Col>
                            </>
                        ) : null}

                        {produtoSelecionado?.opcoes?.length === 0 ? (
                            <Button onClick={handleBack} className={classes.button}>
                                Voltar
                            </Button>
                        ) : (
                            <Button onClick={handleReset} className={classes.button}>
                                Resetar
                            </Button>
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={adicionarProduto(anchor, false, produtoSelecionado)}
                            className={classes.button}
                        >
                            Adicionar{" "}
                            <span className={"valorFinalizarPedido"} style={{ color: "#000000de" }}>
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(calcularValorProduto(produtoSelecionado))}
                            </span>
                        </Button>
                    </Row>
                ) : (
                    <>
                        <Row>
                            <Col xs={12} md={12} lg={12} className="" style={{ padding: "0 5em" }}>
                                <Typography>
                                    {!!grupoDeOpcoesSelecionado.quantidadeMaxima &&
                                        grupoDeOpcoesSelecionado.quantidadeMaxima !== 99999999 && (
                                            <span>
                                                Máximo: {grupoDeOpcoesSelecionado.quantidadeMaxima}
                                            </span>
                                        )}
                                    {!!grupoDeOpcoesSelecionado.quantidadeMaxima &&
                                        grupoDeOpcoesSelecionado.quantidadeMaxima != 99999999 &&
                                        !!grupoDeOpcoesSelecionado.quantidadeMinima &&
                                        grupoDeOpcoesSelecionado.quantidadeMinima != 99999999 && (
                                            <span> e </span>
                                        )}
                                    {!!grupoDeOpcoesSelecionado.quantidadeMinima && (
                                        <span>
                                            Minimo: {grupoDeOpcoesSelecionado.quantidadeMinima}
                                        </span>
                                    )}
                                </Typography>
                            </Col>
                        </Row>

                        {grupoDeOpcoesSelecionado?.adicional === 0 && ( //radio
                            <RadioGroup
                                aria-label={grupoDeOpcoesSelecionado.nome}
                                name={grupoDeOpcoesSelecionado.nome}
                                style={{ marginBottom: "5em" }}
                            >
                                {grupoDeOpcoesSelecionado?.opcoes
                                    ?.sort(function (a, b) {
                                        return sortByOrdemExibicao(a, b)
                                    })
                                    .map((opcao, index) =>
                                        opcao.informativo ? (
                                            <Col
                                                xs={11}
                                                md={11}
                                                lg={11}
                                                style={{ margin: "0.75rem auto" }}
                                            >
                                                <Typography variant="h6">{opcao.nome}</Typography>
                                            </Col>
                                        ) : (
                                            <>
                                                <span
                                                    className="row"
                                                    key={opcao.id}
                                                    style={{
                                                        // "flexWrap": "nowrap",
                                                        alignItems: "center",
                                                        padding: "0.3em 0",
                                                    }}
                                                >
                                                    <Col
                                                        xs={2}
                                                        md={2}
                                                        lg={1}
                                                        style={{
                                                            cursor: "pointer",
                                                            textAlign: "right",
                                                        }}
                                                        className=""
                                                    >
                                                        <FormControlLabel
                                                            value={"#" + opcao.id}
                                                            style={{ margin: 0 }}
                                                            control={
                                                                <Radio
                                                                    id={"#" + opcao.id}
                                                                    color="primary"
                                                                    checked={
                                                                        opcao.quantidade
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    onClick={() => {
                                                                        selecionarRadioButton(
                                                                            opcao,
                                                                            activeStep
                                                                        )
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={7} md={7} lg={8} className="">
                                                        <FormLabel
                                                            style={{ cursor: "pointer" }}
                                                            htmlFor={"#" + opcao.id}
                                                        >
                                                            {opcao.nome}
                                                        </FormLabel>
                                                    </Col>
                                                    {
                                                        //se tiver valor
                                                        opcao.valor && (
                                                            <Col xs={3} md={3} lg={3} className="">
                                                                <FormLabel
                                                                    style={{
                                                                        cursor: "pointer",
                                                                    }}
                                                                    htmlFor={"#" + opcao.id}
                                                                >
                                                                    {Intl.NumberFormat("pt-BR", {
                                                                        style: "currency",
                                                                        currency: "BRL",
                                                                    }).format(opcao.valor)}
                                                                </FormLabel>
                                                            </Col>
                                                        )
                                                    }

                                                    {
                                                        //se tiver descricao
                                                        opcao.descricao ? (
                                                            <>
                                                                <Col xs={12} md={12} lg={1}></Col>

                                                                <Col
                                                                    xs={12}
                                                                    md={12}
                                                                    lg={11}
                                                                    className="colDescricaoAdicional"
                                                                >
                                                                    <FormLabel
                                                                        htmlFor={"#" + opcao.id}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        {opcao.descricao}
                                                                    </FormLabel>
                                                                </Col>
                                                            </>
                                                        ) : null
                                                    }
                                                </span>
                                            </>
                                        )
                                    )}
                            </RadioGroup>
                        )}

                        {grupoDeOpcoesSelecionado?.adicional === 1 && ( //CHECK BOX
                            <FormGroup
                                aria-label="position"
                                name={grupoDeOpcoesSelecionado?.id}
                                style={{ marginBottom: "5em" }}
                            >
                                {grupoDeOpcoesSelecionado?.opcoes
                                    ?.sort(function (a, b) {
                                        return sortByOrdemExibicao(a, b)
                                    })
                                    .map(opcao =>
                                        opcao.informativo ? (
                                            <Col
                                                xs={11}
                                                md={11}
                                                lg={11}
                                                style={{ margin: "0.75rem auto" }}
                                            >
                                                <Typography variant="h6">{opcao.nome}</Typography>
                                            </Col>
                                        ) : (
                                            <>
                                                <span
                                                    className="row"
                                                    key={opcao.id}
                                                    style={{
                                                        // "flexWrap": "nowrap",
                                                        alignItems: "center",
                                                        padding: "0.3em 0",
                                                    }}
                                                >
                                                    <Col
                                                        xs={2}
                                                        md={2}
                                                        lg={1}
                                                        style={{ padding: 0 }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            color="primary"
                                                            value={opcao.nome}
                                                            name={opcao.nome}
                                                            id={"#" + opcao.id}
                                                            checked={
                                                                opcao.quantidade ? true : false
                                                            }
                                                            onClick={() => {
                                                                selecionarCheckButton(
                                                                    opcao,
                                                                    grupoDeOpcoesSelecionado
                                                                )
                                                            }}
                                                            className={
                                                                "#OpcaoDe" +
                                                                grupoDeOpcoesSelecionado?.id
                                                            }
                                                            style={{
                                                                width: "23px",
                                                                height: "23px",
                                                                cursor: "pointer",
                                                                float: "right",
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col xs={7} md={7} lg={8} className="">
                                                        <FormLabel
                                                            style={{
                                                                cursor: "pointer",
                                                                " margin": 0,
                                                            }}
                                                            htmlFor={"#" + opcao.id}
                                                            control={opcao.nome}
                                                        >
                                                            {opcao.nome}
                                                        </FormLabel>
                                                    </Col>
                                                    {
                                                        //se tiver valor
                                                        <Col xs={3} md={3} lg={3} className="">
                                                            {opcao.valor ? (
                                                                <FormLabel
                                                                    htmlFor={"#" + opcao.id}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    {Intl.NumberFormat("pt-BR", {
                                                                        style: "currency",
                                                                        currency: "BRL",
                                                                    }).format(opcao.valor)}
                                                                </FormLabel>
                                                            ) : null}
                                                        </Col>
                                                    }

                                                    {
                                                        //se tiver descricao
                                                        opcao.descricao ? (
                                                            <>
                                                                <Col xs={12} md={12} lg={1}></Col>

                                                                <Col
                                                                    xs={12}
                                                                    md={12}
                                                                    lg={11}
                                                                    className="colDescricaoAdicional"
                                                                >
                                                                    <FormLabel
                                                                        htmlFor={"#" + opcao.id}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        {opcao.descricao}
                                                                    </FormLabel>
                                                                </Col>
                                                            </>
                                                        ) : null
                                                    }
                                                </span>
                                            </>
                                        )
                                    )}
                            </FormGroup>
                        )}

                        {grupoDeOpcoesSelecionado?.adicional === 2 && ( //QTD
                            <FormGroup
                                aria-label={grupoDeOpcoesSelecionado?.id}
                                name={grupoDeOpcoesSelecionado?.id}
                                style={{ marginBottom: "5em" }}
                            >
                                {grupoDeOpcoesSelecionado?.opcoes
                                    ?.sort(function (a, b) {
                                        return sortByOrdemExibicao(a, b)
                                    })
                                    .map((opcao, index2) =>
                                        opcao.informativo ? (
                                            <Col
                                                xs={11}
                                                md={11}
                                                lg={11}
                                                style={{ margin: "0.75rem auto" }}
                                            >
                                                <Typography variant="h6">{opcao.nome}</Typography>
                                            </Col>
                                        ) : (
                                            <>
                                                <span
                                                    key={opcao.id}
                                                    className="camposAddRemoveAdicionaisQuantitativos opcaoIndividual row"
                                                    style={{
                                                        // "flexWrap": "nowrap",
                                                        alignItems: "center",
                                                        padding: "0.3em 0",
                                                    }}
                                                >
                                                    <Col
                                                        xs={4}
                                                        md={3}
                                                        lg={2}
                                                        className="colOpcaoAdicional"
                                                    >
                                                        <ButtonGroup style={{ float: "right" }}>
                                                            <Button
                                                                aria-label="reduce"
                                                                onClick={() => {
                                                                    selecionarQuantidadeButton(
                                                                        opcao,
                                                                        activeStep,
                                                                        "remove"
                                                                    )
                                                                }}
                                                                style={{
                                                                    background: "#dc3545",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                <RemoveIcon fontSize="small" />
                                                            </Button>

                                                            <Button aria-label="increase">
                                                                <span id={opcao.id}>
                                                                    {
                                                                        /*isNaN(opcao.quantidade) ? opcao.quantidade = 0 : opcao.quantidade = */ opcao.quantidade
                                                                    }
                                                                </span>
                                                            </Button>

                                                            <Button
                                                                aria-label="increase"
                                                                style={{
                                                                    background: "#28a745",
                                                                    color: "white",
                                                                }}
                                                                onClick={() => {
                                                                    selecionarQuantidadeButton(
                                                                        opcao,
                                                                        activeStep,
                                                                        "add"
                                                                    )
                                                                }}
                                                            >
                                                                <AddIcon fontSize="small" />
                                                            </Button>
                                                        </ButtonGroup>
                                                    </Col>
                                                    <Col
                                                        xs={5}
                                                        md={6}
                                                        lg={7}
                                                        className="colNomeAdicional"
                                                    >
                                                        <FormLabel>{opcao.nome}</FormLabel>{" "}
                                                    </Col>

                                                    {
                                                        //se tiver valor
                                                        <Col
                                                            xs={3}
                                                            md={3}
                                                            lg={2}
                                                            className="colValorAdicional"
                                                        >
                                                            {(opcao.valor || opcao.valor > 0) && (
                                                                <FormLabel>
                                                                    {Intl.NumberFormat("pt-BR", {
                                                                        style: "currency",
                                                                        currency: "BRL",
                                                                    }).format(opcao.valor)}
                                                                </FormLabel>
                                                            )}
                                                        </Col>
                                                    }

                                                    {
                                                        //se tiver descricao
                                                        opcao.descricao && (
                                                            <>
                                                                <Col xs={12} md={12} lg={2}></Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={12}
                                                                    lg={10}
                                                                    className="colDescricaoAdicional"
                                                                >
                                                                    <FormLabel>
                                                                        {opcao.descricao}
                                                                    </FormLabel>
                                                                </Col>
                                                            </>
                                                        )
                                                    }
                                                    <Divider />
                                                </span>
                                            </>
                                        )
                                    )}
                            </FormGroup>
                        )}

                        <div
                            style={{
                                position: "fixed",
                                bottom: 0,
                                padding: "1em",
                                width: "100%",
                                left: 0,
                                background: "white",
                            }}
                        >
                            {/* <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}> */}
                            <Button onClick={handleBack} className={classes.button}>
                                Voltar
                            </Button>
                            {isStepOptional(activeStep) ? (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSkip}
                                    className={classes.button}
                                >
                                    Pular
                                </Button>
                            ) : null}

                            {console.log(
                                "Valor Button: ",
                                configuracoes.user?.parametros?.limitarQuantidadeItensCentral
                            )}
                            {console.log("Valor Button: ", configuracoes.user?.parametros)}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                disabled={
                                    configuracoes?.user?.parametros
                                        ?.limitarQuantidadeItensCentral &&
                                    grupoDeOpcoesSelecionado?.quantidade <
                                        grupoDeOpcoesSelecionado.quantidadeMinima
                                }
                                className={classes.button}
                            >
                                {activeStep === produtoSelecionado?.opcoes?.length - 1
                                    ? "Finalizar"
                                    : "Próximo"}
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )

    const adicionarProduto = (anchor, open, produto) => event => {
        try {
            console.log("||> adicionarProduto")

            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return
            }
            setState({ ...state, [anchor]: open, right: true })

            const produtoSuccess = produtoProntoParaCarrinho(produto)
            let cart = Object.assign({}, carrinho)
            cart.itens.push(produtoSuccess)
            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
            })
            setCarrinho(cart)
            setActiveStep(0)
        } catch (error) {
            RegistrarLogErro(error, "adicionarProduto", { anchor, open, produto, event })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const isStepOptional = step => {
        if (produtoSelecionado.opcoes[step].quantidadeMinima > 0) {
            return 0
        }
        return 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        if (activeStep === 0) {
            setState({ ...state, bottom: false })
            // handleReset()
        } else {
            setActiveStep(prevActiveStep => prevActiveStep - 1)
        }
    }

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.")
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(prevSkipped => {
            const newSkipped = new Set(prevSkipped.values())
            newSkipped.add(activeStep)
            return newSkipped
        })
    }

    const handleReset = () => {
        const resetProdutoSelecionado = Object.assign({}, produtoSelecionado)
        resetProdutoSelecionado.quantidade = 1
        resetProdutoSelecionado.opcoes.forEach(grupo => {
            grupo.quantidade = 0
            grupo.opcoes.forEach(opcao => {
                opcao.quantidade = 0
            })
        })
        setProdutoSelecionado(resetProdutoSelecionado)
        setActiveStep(0)
    }

    return openCardapio && carrinho.estabelecimento ? (
        <Dialog
            fullScreen
            open={openCardapio}
            onClose={handleCloseCardapio}
            TransitionComponent={Transition}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseCardapio}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                    {!mobile ? (
                        <Typography variant="h6" className={classes.title}>
                            {carrinho.estabelecimento.nome}
                            {/* Cardapio Encontrado */}
                        </Typography>
                    ) : null}

                    {/* {
                carrinho.itens.length 
                ? <> */}
                    <Button color="inherit" onClick={toggleDrawer("right", true)}>
                        Carrinho{" "}
                        {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                            carrinho.valorTotal
                        )}
                    </Button>
                    <Drawer
                        anchor={"right"}
                        open={state["right"]}
                        onClose={toggleDrawer("right", false)}
                    >
                        {list("right")}
                    </Drawer>
                    {/* </>
                : null
              } */}
                </Toolbar>
            </AppBar>

            <Row style={{ margin: "0" }} className={classes.appContainer}>
                {loadingCardapio ? (
                    <Col xs={12} md={12} lg={12}>
                        <Row>
                            <Col xs={12} md={6} lg={6}>
                                <Skeleton variant="rect" width={"100%"} height={65} />
                            </Col>
                            <Col
                                xs={12}
                                md={3}
                                lg={3}
                                style={{ textAlign: "center", alignSelf: "center" }}
                            >
                                <Skeleton variant="rect" width={"100%"} height={35} />
                            </Col>
                            <Col
                                xs={12}
                                md={3}
                                lg={3}
                                style={{ textAlign: "center", alignSelf: "center" }}
                            >
                                <Skeleton variant="rect" width={"100%"} height={35} />
                            </Col>
                        </Row>

                        {listaRepeticao.map((chave, index) => (
                            <React.Fragment key={index}>
                                <Row style={{ padding: "2em 0" }}>
                                    <Col xs={12} md={5} lg={4}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={35}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        ))}
                    </Col>
                ) : (
                    <>
                        <Col xs={12} md={12} lg={12}>
                            <Row style={{ justifyContent: "center" }}>
                                <Col xs={12} md={6} lg={6} className={"mt-3"}>
                                    <TextField
                                        id="procurar-produto"
                                        onChange={e =>
                                            procurarProduto(
                                                e.target.value,
                                                cardapio,
                                                configuracoes.user?.parametros
                                                    ?.permitirBuscaPorAdicionais
                                            )
                                        }
                                        fullWidth
                                        label="Procurar..."
                                        variant="outlined"
                                        style={{ background: "#fff" }}
                                    />
                                </Col>
                                <Col
                                    xs={12}
                                    md={3}
                                    lg={3}
                                    style={{ alignSelf: "center" }}
                                    className={"mt-3"}
                                >
                                    <FormControl
                                        disabled={false}
                                        variant="outlined"
                                        style={{ width: "100%", background: "#fff" }}
                                    >
                                        <InputLabel id="select-categoria-label">
                                            Categoria
                                        </InputLabel>
                                        <Select
                                            defaultValue={-1}
                                            labelId="select-categoria"
                                            id="select-categoria"
                                            label="Categorias"
                                            onChange={e => {
                                                procurarCategoria(e)
                                            }}
                                            fullWidth
                                        >
                                            <MenuItem key={-1} value={-1}>
                                                {"Todas Categorias"}{" "}
                                            </MenuItem>
                                            {cardapio?.categorias.map((categoria, index) =>
                                                categoria.produtos.length ? (
                                                    <MenuItem key={index} value={index}>
                                                        {categoria.nome}
                                                    </MenuItem>
                                                ) : null
                                            )}
                                        </Select>
                                    </FormControl>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} md={12} lg={12} style={{ height: "100%" }}>
                            <TabPanel id="produtosDasCategorias">
                                {cardapio?.id &&
                                    cardapio?.categorias.map((categoria, indexC) =>
                                        categoria.produtos.length ? (
                                            <Row
                                                key={indexC}
                                                id={"primerioC" + indexC}
                                                className={"CardCategoriaCol"}
                                                data-id-categoria={categoria.id}
                                            >
                                                <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginTop: "1em" }}
                                                >
                                                    <Typography style={{ fontSize: "1.5rem" }}>
                                                        <ArrowRightIcon />{" "}
                                                        {categoria.nome[0].toLocaleUpperCase() +
                                                            categoria.nome
                                                                .substring(1)
                                                                .toLocaleLowerCase()}
                                                    </Typography>
                                                </Col>
                                                {categoria.produtos.map((produto, indexP) => (
                                                    <Col
                                                        xs={6}
                                                        md={4}
                                                        lg={3}
                                                        key={produto.id}
                                                        data-id-produto={produto.id}
                                                        className={`CardProdutoCol`}
                                                    >
                                                        <Card
                                                            className={`${classes.rootProduto} ${
                                                                produto.promocional
                                                                    ? "CardProdutoColPromocional"
                                                                    : null
                                                            }`}
                                                            style={{ height: "100%" }}
                                                            onClick={toggleDrawerProduto(
                                                                "bottom",
                                                                true,
                                                                produto
                                                            )}
                                                        >
                                                            <CardActionArea
                                                                style={
                                                                    {
                                                                        /*"height": "100%"*/
                                                                    }
                                                                }
                                                            >
                                                                <CardMedia
                                                                    className={`${
                                                                        produto.urlImagem
                                                                            ? ""
                                                                            : "opacity05"
                                                                    } produtoDeGrid`}
                                                                    image={
                                                                        produto.urlImagem
                                                                            ? produto.urlImagem
                                                                            : produto.produtoExibicao
                                                                            ? Megafone
                                                                            : /**Prato */ Comida
                                                                    }
                                                                    title={produto.nome}
                                                                />
                                                                <CardContent>
                                                                    <Typography
                                                                        gutterBottom
                                                                        style={{ fontSize: "1rem" }}
                                                                        className="nomeProduto"
                                                                    >
                                                                        {produto.nome}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="subtitle2"
                                                                        color="textSecondary"
                                                                        className="descricaoProduto"
                                                                        component="p"
                                                                    >
                                                                        {produto.descricao &&
                                                                        produto.descricao.length >
                                                                            80
                                                                            ? produto.descricao.substring(
                                                                                  0,
                                                                                  mobile ? 40 : 80
                                                                              ) + " [...]"
                                                                            : produto.descricao}
                                                                    </Typography>

                                                                    {produto.produtoExibicao ? (
                                                                        <Typography
                                                                            variant="body2"
                                                                            className="valorProduto"
                                                                            component="p"
                                                                        >
                                                                            Aviso
                                                                        </Typography>
                                                                    ) : (
                                                                        <Typography
                                                                            variant="body2"
                                                                            className="valorProduto"
                                                                            component="p"
                                                                        >
                                                                            {produto.valorDe &&
                                                                            produto.valorDeCalculado >
                                                                                0 ? (
                                                                                <span
                                                                                    style={{
                                                                                        textDecorationLine:
                                                                                            "line-through",
                                                                                        fontSize:
                                                                                            "0.8rem",
                                                                                        color: "rgba(220, 53, 99, 0.54)",
                                                                                    }}
                                                                                >
                                                                                    {Intl.NumberFormat(
                                                                                        "pt-BR",
                                                                                        {
                                                                                            style: "currency",
                                                                                            currency:
                                                                                                "BRL",
                                                                                        }
                                                                                    ).format(
                                                                                        produto.valorDe
                                                                                    )}
                                                                                </span>
                                                                            ) : (
                                                                                <span></span>
                                                                            )}

                                                                            <span className="valorProdutoPromocional">
                                                                                {" "}
                                                                                {produto.valorRealCalculado >
                                                                                    0 &&
                                                                                    Intl.NumberFormat(
                                                                                        "pt-BR",
                                                                                        {
                                                                                            style: "currency",
                                                                                            currency:
                                                                                                "BRL",
                                                                                        }
                                                                                    ).format(
                                                                                        produto.valorRealCalculado
                                                                                    )}
                                                                            </span>
                                                                        </Typography>
                                                                    )}
                                                                </CardContent>
                                                            </CardActionArea>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        ) : null
                                    )}
                            </TabPanel>
                        </Col>
                        {cardapio?.id && produtoSelecionado.id ? (
                            <Drawer
                                anchor={"bottom"}
                                open={state["bottom"]}
                                onClose={toggleDrawer("bottom", false)}
                            >
                                {product("bottom", produtoSelecionado)}
                            </Drawer>
                        ) : null}
                    </>
                )}
            </Row>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
